


import React from 'react'
import { useState, createContext, useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
const AuthContext = createContext(null)
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem('is loggedIn'))
  
  const location = useLocation()
  const login = user => {
    setUser(user)


  }

  const logout = () => {

   
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  
  return useContext(AuthContext)
}
